import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Apply smooth scrolling behavior using CSS
const styles = `
  html {
    scroll-behavior: smooth;
  }
`;

// Use a style tag to inject CSS directly into the document head
const styleTag = document.createElement('style');
styleTag.type = 'text/css';
styleTag.appendChild(document.createTextNode(styles));
document.head.appendChild(styleTag);

export default ScrollToTop;
